import React, { Component } from 'react';
import { navigate, Link } from '@reach/router';

import { withFirebase } from '../components/Firebase';


const LoginPage = () => (
  <div id="login">
    <div className="left">
      <div>
        <div className="logo"><h1><img src='./img/logo.svg' alt="logo"></img></h1></div>
        <div className="image"><img src='./img/wallet.svg' alt="make it rain cash" width="360px" height="auto"></img></div>
        <LoginForm />
      </div>
    </div>
  </div>
);

const INITIAL_STATE = {
  email: '',
  password: '',
  error: null,
  emailError: null,
};


class SignUpFormBase extends Component {
  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE };
  }

  guestLogin = event => {
    this.props.firebase.doSignInAsGuest()
    .then((user) => {
      console.log(user)
      this.setState({ ...INITIAL_STATE })
      navigate('/')
    })
    .catch(error => {
      this.setState({ error })
    });
    event.preventDefault();
  }

  forgotPassword = (e) => {
    const emailAddress = this.state.email;
    if (emailAddress !== '') {
      this.props.firebase.doPasswordReset(emailAddress).then(() => {
        this.setState({ emailError: 'Check your email to reset your password.' })
      }).catch(error => {
        this.setState({ error })
      })
    } else {
      this.setState({ emailError: 'Please enter your email address' })
    }
    e.preventDefault()
  }

  onSubmit = (event) => {
    
    const { email, password } = this.state;

    this.props.firebase.doSignInWithEmailAndPassword(email, password)
      .then((user) => {
        this.setState({ ...INITIAL_STATE })
        navigate('/')
      })
      .catch(error => {
        this.setState({ error });
      });
      event.preventDefault();
  };

  onChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  }

  render() {
    const { email, password, error } = this.state;
    const isInvalid = password === '' || email === '';
    return (
      <div className="form-container">
        <form onSubmit={this.onSubmit} method="POST">
          <label htmlFor="email">Email</label>
          <input name="email" value={email} onChange={this.onChange} type="email" placeholder="user@example.com" />
          <label htmlFor="password">Password</label>
          <input name="password" value={password} onChange={this.onChange} type="password" autoComplete="current-password"  />
          <span onClick={this.forgotPassword} className="forgot">Forgot Password?</span>
          <span className="error">{this.state.emailError}</span>
          {error && <p className="error">{error.message}</p>}
          <button className="dark" disabled={isInvalid} type="submit">Log In</button>
          <button className="light" onClick={this.guestLogin}>Continue as Guest</button>
        </form>
          <span className="create"><Link to="/signup">Create Account</Link></span>
      </div>
    );
  }
}

const LoginForm = withFirebase(SignUpFormBase);


export default LoginPage;

export { LoginForm }